import { useEffect, useState } from "react";

// Media-query hooks for the chat's phone/touch behaviour.
export const MOBILE_QUERY = "(max-width: 767px)";
export const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";

const matches = (query) => typeof window !== "undefined" && Boolean(window.matchMedia?.(query).matches);

export function useMediaQuery(query) {
  const [value, setValue] = useState(() => matches(query));
  useEffect(() => {
    const media = window.matchMedia?.(query);
    if (!media) return undefined;
    const onChange = () => setValue(media.matches);
    onChange();
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [query]);
  return value;
}

// Phone-sized screen: full-screen chat, bottom sheets.
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
// Touch-first device (no hover): long-press and swipe instead of hover toolbars.
export const useIsTouch = () => useMediaQuery(TOUCH_QUERY);
export const isTouchDevice = () => matches(TOUCH_QUERY);
